import { getCountrys } from '@/api/chatbot'
import { checkReq } from '@/utils/util'
import { hasPermission } from '@/directive/permission/hasPermi'
import store from '../index'

export default {
  namespaced: true, // 开启全隔离
  state: {
    countrys: [],
    countryLoading: false,
    companys: []
  },
  mutations: {
    SET_COUNTRY: (state, list) => {
      state.countrys = list
    },
    SET_COMPANYS: (state, list) => {
      // console.log(list)
      state.companys = list
    }
  },
  actions: {
    getCountrys: async ({commit, state}) => {
      if (state.countrys.length || state.countryLoading) return
      state.countryLoading = true
      try {
        const res = await getCountrys()
        if (checkReq(res)) {
          let list = (res.data.data.list || []).filter(v => v.type === 'chatbot')
          commit('SET_COUNTRY', list)
        }
      } catch (err) {}
      state.countryLoading = false
    },
    getCompanys: async ({commit, state}, type = ['*ChatbotCR*selectCountry*']) => {
      const hasSelectContry = hasPermission(type)
      if (hasSelectContry && store.getters.userInfo.company.indexOf('CHATBOT_JT_') === 0) {
        try {
          const res = await getCountrys()
          if (checkReq(res)) {
            const { list } = res.data.data || []
            let _list = list.filter(v => v.type === 'chatbot')
            // console.log('SET_COMPANYS===>', _list)
            commit('SET_COMPANYS', [...new Set(_list.map(v => v.company_name))])
          }
        } catch (err) {}
      } else {
        commit('SET_COMPANYS', [store.getters.userInfo.company])
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chatbot.js